import { Component, Input, OnInit } from '@angular/core';
import { Orders, StatusButtons } from "../../../../_shared/interfaces";
import { AlertService, IAlertType, OrdersStoreService } from "../../../../_shared/services";
import { ClrDatagridModule, ClrDatagridSortOrder } from "@clr/angular";
import { RouterLink } from "@angular/router";
import { CurrencyPipe, DatePipe } from "@angular/common";

@Component({
  selector: 'app-project-details-order',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    CurrencyPipe
  ],
  templateUrl: './project-details-order.component.html',
  styleUrl: './project-details-order.component.sass'
})
export class ProjectDetailsOrderComponent implements OnInit {
  orders: Orders[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusText = '';

  projectId: string = '';

  @Input() cid: number = 0;
  @Input() prid: string = '';

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'confirmed', display: 'Bestätigt', label: 'alert-info', icon: 'check-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Überfällig', label: 'alert-danger', icon: 'exclamation-triangle'},
    { state: 'incomplete', display: 'Unvollständig', label: 'alert-danger', icon: 'exclamation-triangle'},
    { state: 'storno', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'shipped', display: 'Abgeschickt', label: 'alert-success', icon: 'check-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-green', icon: 'exclamation-circle'},
    { state: 'done', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
      private ordss: OrdersStoreService,
      private alertDispatcher: AlertService,
  ) { }

  ngOnInit() {
    this.loading = true;
    this.projectId = this.cid + '.' + this.prid;
    this.loadList();
  }

  loadList() {
    this.ordss.getOrders(this.projectId,0, 0, 'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Orders gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        this.orders = data.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return
      }
    });
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(orderstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === orderstatus)
  };

  getCellStatus(status: string) {
    const statusline = this.findButtonStatus(status, this.statusButtons);
    return {
      'statusLabel': this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(orderstatus: string) {
    return "alert " + this.getCellStatus(orderstatus).statusLabel + " alert-sm";
  }
}
